<template>
  <div class="summary_module">
    <el-row>
      <el-col :span="4">&nbsp;</el-col>
      <el-col :span="8">
        <video width="100%" height="100%" controls ref="video">
        </video>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="8">
        <div class="h_summary_title">
          <span class="mainTitle">{{summaryTitle}} /</span>
          <span class="mSubStl subTitle">{{subTitle1}}</span>
          <span class="mianColo subTitle">{{subTitle2}}</span>
        </div>
        <p class="chapter_text" v-html="briefSummary"></p>
      </el-col>
      <el-col :span="3">&nbsp;</el-col>
    </el-row>
    <div class="more_btn_cup">
      <el-button class="more_btn " @click="seeMore">
        查看更多&nbsp;&nbsp;<i class="el-icon-right more_icon"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import { companySummaryInfos } from '@/api/frontApi/company';
export default {
  data() {
    return {
      movieSrc: '',
      summaryTitle: '公司简介',
      subTitle1: 'Company',
      subTitle2: 'Profile',
      briefSummary: ''
    };
  },
  created() {
    this.getMovie();
    this.getSummary();
  },
  methods: {
    getContent(content) {
      let reg = /<\/?.+?\/?>/g;
      return content.replace(reg, '');
    },
    getMovie() {
      companySummaryInfos({ companyOrder: 1 }).then(res => {
        this.$refs.video.src = res.data.companyBody;
      });
    },
    getSummary() {
      companySummaryInfos({ companyOrder: 2 }).then(res => {
        this.briefSummary = res.data.companyBody;
      });
    },
    seeMore() {
      this.$router.push({
        name: 'company',
        params: {
          sumType: 1
        }
      });
    }
  }
};
</script>
<style scoped>
.summary_module {
  width: 100%;
  height: 100%;
  background-image: url('../../../../static/img/syscom/bkg-com.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 25px 0 5px;
}
.h_summary_title {
  height: 40px;
}
.chapter_text {
  text-indent: 2em;
  line-height: 30px;
  color: #000;
  width: 100%;
  /* height: 80%; */
  height: 295px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 10; /*第10行显示 ...*/
  -webkit-box-orient: vertical;
}
.more_btn_cup {
  width: 100%;
  text-align: center;
}
.more_btn {
  background: rgba(223, 238, 242, 0.5);
}
.more_btn:hover {
  background-color: #00697f;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/homeSummary.vue